import * as React from 'react';
import { Alert, Col, Row } from 'reactstrap';
import FAIcon from '../fAIcon/FAIcon';
import './ItemEditComponent.css';

export interface ItemEditComponentProps {
    cancelHandler: () => void;
    content: React.ReactNode;
    contentEdit: React.ReactNode;
    deleteHandler?: () => void;
    editHandler: () => void;
    editState: EditState;
    error?: boolean;
    disabled: boolean;
    errorMessage?: string;
    name?: string;
    saveHandler: () => void;
    ValidationError?: boolean;
    vaildationMessage?: string;
}

export enum EditState {
    None,
    This,
    Other,
}

export const ItemEditComponent = (props: ItemEditComponentProps) => {
    if (props.editState === EditState.None) {
        return (
            <>
                {props.name && <h4>{props.name}</h4>}
                <div className="myCommissionItem">
                    <div>{!props.error && props.content}</div>
                    <div>
                        {props.deleteHandler ? (
                            <a className="iconButton" onClick={props.deleteHandler}>
                                <FAIcon mouseHover="löschen" icon="trash" />
                            </a>
                        ) : null}
                        {!props.disabled && (
                            <a className="iconButton" onClick={props.editHandler}>
                                <FAIcon mouseHover="bearbeiten" icon="edit" />
                            </a>
                        )}
                    </div>
                </div>
            </>
        );
    } else if (props.editState === EditState.This) {
        return (
            <Col>
                {props.name && <h4>{props.name}</h4>}
                <div className="myCommissionItem editing asRow">
                    <div>{props.contentEdit}</div>
                    <a className="iconButton" onClick={props.cancelHandler}>
                        <FAIcon mouseHover="abbrechen" icon="times-circle" />
                    </a>
                    {!props.ValidationError && (
                        <a className="iconButton" onClick={props.saveHandler}>
                            <FAIcon mouseHover="speichern" icon="save" />
                        </a>
                    )}
                    {/* <Row>{props.ValidationError && <Alert color="danger">{props.vaildationMessage}</Alert>}</Row> */}
                </div>
            </Col>
        );
    } else {
        return (
            <Col>
                {props.name && <h4>{props.name}</h4>}
                <div className="myCommissionItem">
                    {!props.error && <Row>{props.content}</Row>}
                    <Row>{props.error && <Alert color="danger">{props.errorMessage}</Alert>}</Row>
                </div>
            </Col>
        );
    }
};



// WEBPACK FOOTER //
// ./src/components/itemEditComponent/ItemEditComponent.tsx